// extracted by mini-css-extract-plugin
export default {"principal":"style_principal__kQ23j","result":"style_result__IKKIz"};